import { useState } from "react";
import { useBetween } from "use-between";

export const useIsExpanded = () => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  return { isExpanded, setIsExpanded };
}

export const useCurrentStep = () => {
  const [value, setValue] = useState<number>(0);
  return { step: value, setStep: setValue };
}

export const useSharedIsExpanded = () => useBetween(useIsExpanded)
export const useSharedCurrentStep = () => useBetween(useCurrentStep)